import React, { useEffect, useState } from "react";
import { Formik, Field, Form, useField, ErrorMessage } from 'formik';
import styles from "./newbroadcast.module.css";
import {
  FormFieldLabel as Label,
  FormErrorLabel as ErrorLabel,
} from "../../../components/label/Labels";
import { FormTextArea, TextInput } from "../../../components/input/inputs";
import * as Yup from "yup";
import { Submit, BackButton } from "../../../components/button/buttons";
import Asterisk from "../../../components/asterisk/Asterisk";
import IMAGES from "../../../assets/images/images";
import { Sidebar } from "../../../components/sidebar/Sidebar";
import * as DOMPurify from 'dompurify';
import { ADD_TICKET_ACTION, MAX_FILES } from "../../../utils/constants/incidentConstants";
import moment from 'moment';
import { formatDate } from "../../../utils/arrayUtils";
import { ADD_BROADCAST_ACTION, STATUS_ENUM } from "../../../utils/constants/broadcastConstants";
import { Loader } from "../../../components/loader/Loader";
import SecondaryTooltip from "../../../components/secondaryToolTip/secondaryToolTip";

const ButtonWrapper = ({ children }) => {
  return <div className={styles.buttonContainer}>{children}</div>;
};
const FieldWrapper = ({ children }) => {
  return <div className={styles.fieldContainer}>{children}</div>;
};


const TextArea = ({ ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError
    ? `${styles.input} ${styles.inputError}`
    : styles.input;
  return (
    <div className={props.isExpandedField ? `${styles.Field} ${styles.expandedField}` : `${styles.Field}`}>
      <div>
        <Label
          htmlFor={props.htmlFor}
          text={props.label}
          style={styles.lable}
        />
        {props.isMandatory ? <Asterisk /> : <></>}
        {
          props.showTooltip ?
            <>
              &nbsp;&nbsp;
              {/* <Tooltip text={props.tooltipText} /> */}
            </>
            : <></>
        }
      </div>
      {
        !props.isPreviewMode ?
          <>
            <FormTextArea
              {...field}
              placeholder={props.placeholder}
              style={inputStyle} />
            <span className={styles.textLimitInfo}>{props.textLimit}</span>
            {hasError ? <ErrorLabel text={meta.error} /> : null}
          </> :
          <div className={styles.previewText}>
            {field?.value ? field?.value.split('\n').map(text => <div>{text}</div>) : "---"}
          </div>
      }

    </div>
  );
};

const TextField = ({ disabled = false, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError
    ? `${styles.input} ${styles.inputError}`
    : styles.input;

  return (
    <div className={props.isExpandedField ? `${styles.Field} ${styles.expandedField}` : `${styles.Field}`}>
      <div>
        <Label
          text={props.label}
          style={styles.lable}
        />
        {props.isMandatory ? <Asterisk /> : <></>}
        {
          props.showTooltip ?
            <>
              &nbsp;&nbsp;
              {/* <Tooltip text={props.tooltipText} /> */}
            </>
            : <></>
        }
      </div>
      {
        !props.isPreviewMode ?
          <>
            <TextInput
              name={props.name}
              placeholder={props.placeholder}
              type={props.type}
              disabled={disabled}
              {...field} style={inputStyle}
            />
            <span className={styles.textLimitInfo}>{props.textLimit}</span>
            {hasError ? <ErrorLabel text={meta.error} /> : null}

          </> :
          <div className={styles.previewText}>
            {
              props.type == "datetime-local" && field?.value ?
                moment(field?.value).format('DD MMM YYYY HH:mm') :
                field?.value ?
                  field?.value :
                  "---"
            }</div>
      }
    </div>
  )
}
const CheckBox = ({ name,label, value, isPreviewMode }) => {

  return (
    <FieldWrapper>
      <label className={styles.wrapper}>
        <Field
          className={styles.checkboxs}
          type="checkbox"
          name={name}
          value={value}
          disabled={isPreviewMode}
        />
        <span className={styles.label}>{label}</span>
      </label>
    </FieldWrapper>
  );
};


export const DateTimeTextField = ({ disabled = false, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError
    ? `${styles.input} ${styles.inputError}`
    : styles.input;

  return (
    <div className={ `${styles.Field}`}>
      <div>
        <Label
          text={props.label}
          style={styles.lable}
        />
        {props.isMandatory ? <Asterisk /> : <></>}
        {
          props.showTooltip ?
            <>
              &nbsp;&nbsp;
              {/* <Tooltip text={props.tooltipText} /> */}
            </>
            : <></>
        }
      </div>
      {
        !props.isPreviewMode ?
          <>
            <TextInput
              name={props.name}
              placeholder={props.placeholder}
              type={props.type}
              disabled={disabled}
              min={props.min}
              max={props.max}
              {...field} style={inputStyle}
              onChange={(e) => {
                const value = e.target.value;
                helpers.setValue(value);
                if (props.onChange) {
                  props.onChange(value);
                }
              }}
            />
            <span className={styles.textLimitInfo}>{props.textLimit}</span>
            {hasError ? <ErrorLabel text={meta.error} /> : null}
          </> :
          <div className={styles.previewText}>
            {props.type == "datetime-local" && field?.value ?
              moment.tz(field.value, moment.tz.guess()).format('DD MMM YYYY HH:mm z') : "---"
            }</div>
      }
    </div>
  )
}
const ConfirmationPopup = ({ onConfirm, onCancel,data='',header="",isEditSubmit }) => {
  return (
    <div className={styles.confirmationpopup}>
      <div className={styles.confirmationpopupcontent}>
        <div className={styles.header}>
          <div className={styles.headertxt}>{header}</div>
          <div><img onClick={onCancel} className={styles.close} src={IMAGES.close}/></div>
        </div>
        <div>{data}</div>
        <div className={styles.buttons} >
        <button className={styles.cancle} onClick={onCancel}>No, Cancel</button>
        {!isEditSubmit ?<button className={styles.submit} onClick={onConfirm}>Yes, Continue</button>: <div className={styles.confirmloader}><Loader/></div>}
        </div>
      </div>
    </div>
  );
};

const AddNewBoradcast = ({...props}) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEditSubmit, setEditIsSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [isPreviewMode, setPreviewMode] = useState(true)
  const [showPopup, setShowPopup] = useState(false);
  const close = () => { setShow(false); setPreviewMode(true) };
  const statusFilter = Object.keys(props.checkedStatuses || {}).filter((key) => props.checkedStatuses?.[key]).join(",");

  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success
  });

  const handleCancelClick = (close) => {
    setShowPopup(true);

  };

  const handleConfirm = () => {
    setEditIsSubmit(true); 
     const payload = {
      status: props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "stop" : "cancel" 
    };
    props.SubmitstopBroadcast(payload,props.initaldata.id).then((result) => {
      if (result.status) {
        props.openAlertPopup({
          message: `Broadcast message has been ${props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "stopped" : "cancelled"} successfully!`,
          image: IMAGES.success,
        });
        setEditIsSubmit(false);
        setShowPopup(false);
        props.getBroadcastList(null,statusFilter,"desc");
        close()
      } else {
        let error_msg = result?.error?.message ?? "Something went wrong.";
        props.openAlertPopup({
          message: error_msg,
          image: IMAGES.error,
        });
        setShowPopup(false);
        close()
        setEditIsSubmit(false);
      }
    })
    .catch((error) => {
      props.openAlertPopup({
        message: "Something went wrong.",
        image: IMAGES.error,
      });
      setShowPopup(false);
      close()
      setEditIsSubmit(false);
    });
  };

  const handleCancel = () => {
    setShowPopup(false);
    close();
    setEditIsSubmit(false);
  };


  function convertUnixToDatetimeLocal(ts) {
     const date = new Date(ts * 1000); 
     const year = date.getFullYear();
     const month = String(date.getMonth() + 1).padStart(2, '0'); 
     const day = String(date.getDate()).padStart(2, '0');
     const hours = String(date.getHours()).padStart(2, '0');
     const minutes = String(date.getMinutes()).padStart(2, '0');
    
     return `${year}-${month}-${day}T${hours}:${minutes}`;
    } 
  let _initialValues = {}
  if (props.actionType === ADD_BROADCAST_ACTION.BROADCAST_DETAILS) {
    _initialValues = {
      title: props.initaldata?.title,
      message: props.initaldata?.message,
      recipients:props.initaldata?.recipients,
      date_from: convertUnixToDatetimeLocal(props?.initaldata?.startTime),
      date_to: convertUnixToDatetimeLocal(props?.initaldata?.expiryTime),
    };
  } else {
    _initialValues = {
      title: "",
      message: "",
      recipients: [],
      date_from: "",
      date_to: "",
    };
  }
  const validationSchema = Yup.object({
    title: Yup.string().max(100,"Title must be at most 100 characters").required("Required"),
    message: Yup.string().max(1000,"Message must be at most 1000 characters").required("Required"),
    recipients: Yup.array().min(1, "At least one recipient must be selected").required("Required"),
    date_from: Yup.string().required("Required"),
    // .test({
    //   name: 'Time',
    //   message: "Future Date or Time not allowed.",
    //   test: function (value) {
    //     const currentDateTime = moment().format('YYYY-MM-DDTHH:mm')
    //     if (value < currentDateTime) {
    //       return false;
    //     }
    //     return true;
    //   }
    // }),
    date_to: Yup.string().required("Required"),
    // .test({
    //   name: 'Time',
    //   message: "not allowed.",
    //   test: function (value) {
    //     const selectedDateFrom = moment(value.date_from).format('YYYY-MM-DDTHH:mm')
    //     if (value < selectedDateFrom) {
    //       return false;
    //     }
    //     return true;
    //   }
    // }),
  });
  
function convertLocalToUTC(dateTimeStr) {
   const localDate = new Date(dateTimeStr);
   return localDate.toISOString();
  }
  
  return (
    <>
      {props.actionType === ADD_BROADCAST_ACTION.BROADCAST_DETAILS ?
        <span className={styles.open} onClick={() => { setShow(true); }}>
          <SecondaryTooltip text={props?.initaldata?.title} positions={['bottom', 'right']} >
          {props?.initaldata?.title}
          </SecondaryTooltip>
        </span> :
        <button onClick={() => { setShow(true); setPreviewMode(false) }} className={styles.addcomment}>Create New</button>}
      {show && (
        <Sidebar isOpen={show} headerTxt={props?.initaldata?.status.value == "live" ? "Live Message Details " : props?.initaldata?.status.value == "scheduled" ? "Scheduled Message Details" : props?.initaldata?.status.value == "closed" ? "Closed Message Details" : "Broadcast Message Form"} onClose={close} sideNavStyle={styles.sideNavStyle}>
          <Formik
            initialValues={_initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            validateOnChange
            onSubmit={async (values, { resetForm }) => {
              if (!isPreviewMode) {
                setIsSubmit(true);
                let obj = {
                  title: values.title,
                  message: values.message,
                  recipients: values.recipients,
                  startTime: convertLocalToUTC(values.date_from),
                  expiryTime: convertLocalToUTC(values.date_to),
                }
                if(props.actionType === ADD_BROADCAST_ACTION.BROADCAST_DETAILS){
                  props.SubmitUpdateBroadcast(obj,props?.initaldata?.id).then((result) => {
                   if (result.status) {
                     props.openAlertPopup({
                       message: `Broadcast message has been updated successfully!.`,
                       image: IMAGES.success,
                     });
                     setIsSubmit(false);
                     close();
                     resetForm();
                     props.getBroadcastList(null,statusFilter,"desc");
                   } else {
                     let error_msg = result?.error;
                     props.openAlertPopup({
                       message: error_msg,
                       image: IMAGES.error,
                       isFormOpen:true
                     });
                     setIsSubmit(false);
                    //  close();
                   }
                 })
                   .catch((error) => {
                     props.openAlertPopup({
                       message: "Something went wrong.",
                       image: IMAGES.error,
                     });
                     setIsSubmit(false);
                     close();
                   });
                }else{
                props.SubmitBroadcastRequst(obj).then((result) => {
                  if (result.status) {
                    props.openAlertPopup({
                      message: `A new broadcast message has been created successfully!.`,
                      image: IMAGES.success
                    });

                    setIsSubmit(false);
                    close();
                    resetForm();
                    props.getBroadcastList(null,statusFilter,"desc");
                  } else {
                    let error_msg = result?.error;
                    props.openAlertPopup({
                      message: error_msg,
                      image: IMAGES.error,
                      isFormOpen:true
                    });
                    setIsSubmit(false);
                    // close();
                  }
                })
                  .catch((error) => {
                    props.openAlertPopup({
                      message: "Something went wrong.",
                      image: IMAGES.error,
                    });
                    setIsSubmit(false);
                    close();
                  });
                }    
              } else {
                setPreviewMode(false);
              }
            }}
          >
            {({ values, isValid, dirty, setFieldValue, resetForm, handleSubmit }) => (
              <>
                <Form
                  className={`${styles.form} ${styles.scroll}`}
                  id="id_comment_form"
                  onSubmit={handleSubmit}
                >
                  <div className={styles.commentpart}>
                    <TextField
                      label="Title"
                      type="text"
                      name="title"
                      isMandatory={true}
                      placeholder="Enter here"
                      isExpandedField={true}
                      showTooltip={true}
                      tooltipText={"Title"}
                      textLimit={`${values?.title?.length}/100 characters`}
                      isPreviewMode={isPreviewMode}
                    />
                    <div className={styles.gap}>
                      <TextArea
                        label="Message"
                        name="message"
                        isMandatory={true}
                        placeholder="Enter here"
                        isExpandedField={true}
                        showTooltip={true}
                        tooltipText={"Additional Information"}
                        textLimit={`${values?.message?.length}/1000 characters`}
                        isPreviewMode={isPreviewMode}
                      />
                    </div>
                    <div className={styles.linehr}></div>
                    {isPreviewMode ? <div className={styles.checkboxlabel}><div className={styles.checkbox}>Recipients<Asterisk/></div><div></div></div> :
                      <div className={styles.checkboxlabel}><div className={styles.checkbox}>Choose Recipients</div><div><Asterisk/></div></div>}
                    <FieldWrapper>
                      <div className={styles.checkboxalign}>
                        <CheckBox
                          name="recipients"
                          value="customer"
                          label="Customer"
                          isPreviewMode={isPreviewMode}
                        />
                        <CheckBox
                          name="recipients"
                          value="internal"
                          label="Internal"
                          isPreviewMode={isPreviewMode}
                        />
                      </div>
                      <ErrorMessage name={"recipients"}>
                        {(msg) => <ErrorLabel text={msg} />}
                      </ErrorMessage>
                    </FieldWrapper>
                    <div className={styles.hrline}></div>
                    {!isPreviewMode && <div className={styles.datelabel}>Schedule Date & Time (In UTC)</div>}
                    <div className={isPreviewMode ? ` ${styles.select} ${styles.datelabel}` : `${styles.select}`}>
                      <div className={`${styles.selectwidth} ${styles.dropdownwidths}`}>
                        <DateTimeTextField
                          label="From Date/Time"
                          name="date_from"
                          isMandatory={true}
                          type="datetime-local"
                          placeholder="Enter here"
                          textLimit={null}
                          disabled={props?.initaldata?.status?.value === STATUS_ENUM.LIVE ? true:false}
                          min={props?.initaldata?.status?.value !== STATUS_ENUM.LIVE ? moment().format('YYYY-MM-DDTHH:mm'):""}
                          isPreviewMode={isPreviewMode}
                          onChange={(value) => {
                            setFieldValue('date_from', value);
                            setFieldValue('date_to', '');
                          }}
                        />
                      </div>
                      <div className={styles.selectwidth}>
                        <DateTimeTextField
                          label="To Date/Time"
                          name="date_to"
                          isMandatory={true}
                          type="datetime-local"
                          placeholder="Enter here"
                          textLimit={null}
                          min={moment(values.date_from).format('YYYY-MM-DDTHH:mm')}
                          isPreviewMode={isPreviewMode}
                        />
                      </div>
                    </div>

                  </div>
                               
                </Form>
                <div className={styles.footer}>
                {isPreviewMode && props?.initaldata?.status?.value !== STATUS_ENUM.CLOSED ?
                    <div className={styles.note}>To <span>{props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "stop" : "cancel"}
                    </span> this broadcast, please click the <span className={styles.notespan}>{props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "'Stop Broadcast'" : "'Cancel Broadcast'"}</span> button. </div> : <div className={styles.noteclose}></div>}
                  <hr className={styles.separator} />
                  <ButtonWrapper>
                    {props?.initaldata?.status.value !== STATUS_ENUM.CLOSED &&
                      <div className={styles.backButton}
                        onClick={() => {
                          if (props?.initaldata?.status?.value !== STATUS_ENUM.CLOSED && props?.initaldata?.status?.value !== undefined) {
                            handleCancelClick(close);
                          } else {
                            close()
                          }
                        }}
                      >{props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "Stop Broadcast " : props?.initaldata?.status.value == STATUS_ENUM.SCHEDULE ? "Cancel Broadcast " : "Back"}
                      </div>}
                    {props?.initaldata?.status.value == STATUS_ENUM.CLOSED ?
                      <div className={styles.closeButton}
                        onClick={close}
                      >
                        Close
                      </div> :
                      <Submit
                        id="saveButton"
                        className={styles.saveButton}
                        style={styles.submit}
                        title={isPreviewMode ? "Edit" : (props.actionType === ADD_BROADCAST_ACTION.BROADCAST_DETAILS ? "Save Changes" : "Submit")}
                        form="id_comment_form"
                        isSubmitting={isSubmit}
                        loaderstyle={styles.loader}
                        disabled={!isValid || (!isPreviewMode ? !dirty : false)}
                      />}
                  </ButtonWrapper>
                </div>
                {showPopup && (
                  <ConfirmationPopup
                    header={props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "Stop Broadcasting " : "Cancel Broadcasting "}
                    data={<span className={styles.conform}>Are you sure you want to {props?.initaldata?.status.value == STATUS_ENUM.LIVE ? "stop broadcasting " : "cancel broadcasting "} this message?</span>}
                    isEditSubmit={isEditSubmit}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                  />)}
              </>
            )}
          </Formik>
        </Sidebar>
      )}
    </>
  )
};


export default AddNewBoradcast;

